import React, { useEffect, useRef, useState } from "react";
import "../ScrollReveal.css";

export default function ScrollRevealDiv({ children }) {
  const ref = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(ref.current); // only animate once
        }
      },
      {
        threshold: 0.1, // trigger when 10% is visible
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);

  return (
    <div
      ref={ref}
      className={`scroll-reveal-wrapper ${isVisible ? "visible" : ""}`}
    >
      {children}
    </div>
  );
}
